export const PESTEL_ROWS = [
  { key: "political", title: "Political" },
  { key: "economic", title: "Economic" },
  { key: "social", title: "Social" },
  { key: "technological", title: "Technological" },
  { key: "environmental", title: "Environmental" },
  { key: "legal", title: "Legal" },
];
export const SCOPES = [
  { key: "local", title: "Local" },
  { key: "national", title: "National" },
  { key: "global", title: "Global" },
];

export default function LongPestelBlueprint({ doc }) {
  const p = doc.payload || {};
  return (
    <div className="overflow-x-auto" data-testid="pestel-blueprint">
      <table className="w-full min-w-[720px] border border-slate-200 rounded-sm overflow-hidden text-left">
        <thead>
          <tr className="bg-slate-900 text-white text-[11px] uppercase tracking-wider">
            <th className="px-4 py-2.5 font-semibold w-32">Vector</th>
            {SCOPES.map((s) => <th key={s.key} className="px-4 py-2.5 font-semibold">{s.title}</th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-200">
          {PESTEL_ROWS.map((r) => {
            const cell = p[r.key] || {};
            return (
              <tr key={r.key} data-testid={`pestel-row-${r.key}`} className="align-top">
                <td className="px-4 py-3 bg-indigo-50 border-r border-slate-200 font-mono text-xs font-bold uppercase text-indigo-700">{r.title}</td>
                {SCOPES.map((s) => (
                  <td key={s.key} className="px-4 py-3 text-sm text-slate-800 border-r border-slate-100 last:border-r-0 whitespace-pre-wrap">{cell[s.key] || <span className="text-slate-300">—</span>}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
